/**
 * @param {string} date
 * @returns ISO-8601 Date YYYY-MM-DD or undefined if date is invalid
 */
export const dateToYYYYMMDD = (date: string): string | undefined => {
  try {
    return new Date(date).toISOString().split('T')[0];
  } catch (e) {
    return undefined;
  }
};
